import React from "react";
import ComplianceTab from "../../ComplianceTab";
import "../settings.css";

/**
 * Command Center settings panel (redesign).
 *
 * Maps 1:1 to the existing, production-wired `ComplianceTab` component
 * (Document Templates / Charting / Score Weights sub-tabs, all
 * `services/compliance` wiring intact). Per the build spec we REUSE that
 * component wholesale and only wrap it in the redesign chrome — we do NOT
 * rebuild its data/save logic or its sub-tab bar.
 *
 * Admin-only: the existing Settings page gates this tab behind
 * `profile.user.type !== "staff"`; we honour the same rule here.
 */
export default function CommandCenterPanel({ profile, role }) {
  // Primary admin/staff discriminator matches the existing Settings page
  // (`profile.user.type === "staff"`). Fall back to the `role` prop the
  // shell passes ("staff" | "admin") if the profile isn't hydrated yet.
  const userType = profile?.user?.type;
  const isStaff = userType ? userType === "staff" : role === "staff";

  if (isStaff) {
    // Command Center settings are admin-only. Staff should never reach this
    // panel (the shell hides the nav item), but guard defensively.
    return (
      <div className="settings-redesign">
        <div className="settings-panel active" data-panel="command-center">
          <div className="page-header">
            <div>
              <div className="page-title">Command Center</div>
              <div className="page-subtitle">
                Document templates, charting rules, and compliance scoring.
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-section">
              <div className="card-title">Administrator access required</div>
              <div className="card-subtitle">
                Command Center configuration is only available to administrators.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="settings-redesign">
      <div className="settings-panel active" data-panel="command-center">
        <div className="page-header">
          <div>
            <div className="page-title">Command Center</div>
            <div className="page-subtitle">
              Document templates, charting rules, and compliance scoring.
            </div>
          </div>
        </div>

        {/*
          Reuse the existing ComplianceTab wholesale. It already renders the
          three sub-tabs the design calls for (Document Templates / Charting /
          Settings → Score Weights), each backed by `services/compliance`
          (getDocumentTemplates, toggleDocumentTemplate, toggleDocumentFolder,
          createCustomFolder, addCustomItem, getComplianceSettings,
          updateComplianceSettings, ...). No props = full standalone mode,
          exactly as the live Settings page renders it.
        */}
        <ComplianceTab />
      </div>
    </div>
  );
}
